import { Controller } from "@hotwired/stimulus"

// Kontroler formularza zadań cyklicznych
// Pokazuje/ukrywa sekcje w zależności od wybranego rodzaju (kind)
export default class extends Controller {
  static targets = ["templateSection", "inlineSection"]

  connect() {
    // nasłuchuj na zmianę selecta kind
    const kindSelect = this.element.querySelector("select[name='recurring[kind]']")
    if (kindSelect) {
      kindSelect.addEventListener("change", () => this.updateVisibility())
    }
    this.updateVisibility()
  }

  updateVisibility() {
    const kindSelect = this.element.querySelector("select[name='recurring[kind]']")
    if (!kindSelect) return

    const isInline = kindSelect.value === "task_inline"

    // sekcje wyboru szablonu - ukryj dla inline
    this.templateSectionTargets.forEach(el => {
      el.classList.toggle("hidden", isInline)
    })

    // sekcja danych inline - pokaż dla inline
    this.inlineSectionTargets.forEach(el => {
      el.classList.toggle("hidden", !isInline)
    })
  }
}
